import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { commentsApi, Comment } from '../api/commentsApi';

const REPLICATION_REGEX = /\[FROM\s+[A-Z]+-\d+\]\s*/;

export const useIssueComments = (issueKey: string) => {
  const {
    data: comments = [],
    isLoading,
    error,
  } = useQuery<Comment[]>({
    queryKey: ['comments', issueKey],
    queryFn: () => commentsApi.fetchComments(issueKey),
    enabled: !!issueKey,
  });

  const cleanedComments = useMemo(() =>
    comments.map(comment => ({
      ...comment,
      text: comment.text?.replace(REPLICATION_REGEX, '') || '',
    })),
    [comments]
  );

  return {
    comments: cleanedComments,
    isLoading,
    error: error as Error | null,
  };
};
